import React from "react";
import { Grid, Typography } from "@mui/material";
import { PartnerArrowIcon } from "../../../res/NewWebIcons"; 

const PayInBreadcrumb = () => {
  return (
    <Grid
      style={{
        display: "flex",
        alignItems: "center",
        gap: "1%",
        justifyContent: "start",
      }}
    >
      <Typography color="textSecondary" style={{ fontSize: "14px" }}>
        Reports
      </Typography>
      <PartnerArrowIcon />
      <Typography color="textSecondary" style={{ fontSize: "14px" }}>
        Pay In Report
      </Typography>
    </Grid>
  );
};

export default PayInBreadcrumb;
